import React, { useRef } from 'react';
import './EventsListingCard.css'
import offerPopImage from "./image/offer-pops-image.svg"
import { IoShareSocialOutline } from "react-icons/io5";
import { FaRegBookmark } from "react-icons/fa";

import { FaCalendarAlt, FaClock, FaMapMarkerAlt, FaRupeeSign, FaStar, FaDoorOpen } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { add } from 'date-fns';
import { API_BASE_URL, isPastDate } from '../utils';

const EventsListingCard = ({
    title,
    date,
    clubName,
    areaName,
    time,
    rating,
    location,
    distance,
    type,
    price,
    image,
    video,
    offer,
    eventid,
    clubid,
    isEventThankyou,
    distancetotal,
    club_slug,
    club_img,
    addon,
    discount,
    isCarnival

}) => {

    const url = `${API_BASE_URL}/master/assets/uploads/`;

    const navigate = useNavigate();




    return (
        <div className="event-card-container" >
            <div className="event-card-image-wrapper">
                <div className="event-card-image-overlay-bg"></div>
                {video ? (
                    <video autoPlay muted loop playsInline className="event-card-image">
                        <source src={url + video} type="video/mp4" />
                    </video>
                ) : (
                    <img
                        src={image}
                        alt="Percussion Night"
                        className="event-card-image"
                        loading="lazy"
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGV2ZW50fGVufDB8fDB8fHww`;
                        }}
                    />
                )}
                {offer && (
                    <img className='offer-pop' src={offerPopImage} alt="offer-pop-image" />
                )}

                {isEventThankyou && (
                    <>
                        <div className='event-card-image-overlay-event-thankyou-tag'>
                            <p>My Choice</p>
                        </div>
                    </>
                )}
                <div className="event-card-actions">
                    <span className="event-card-action-btn"><FaRegBookmark /></span>
                    <span
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            // downloadAndShare();
                        }}
                        className="event-card-action-btn"
                    >
                        <IoShareSocialOutline />
                    </span>
                </div>
                {offer && (
                    <div className="event-card-image-offer-overlay">
                        <div className="event-card-image-offer-box">
                            <p>{offer}</p>
                        </div>
                    </div>
                )}

            </div>
            <div className="event-card-details">
                <h3 className="event-card-title">
                    {title?.length > 25 ? title?.slice(0, 25) + '...' : title}
                </h3>
                <div className="event-card-club" onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    navigate(`/${club_slug}`);
                }}>
                    <span className='event-card-club-logo'><img src={club_img} alt="" onError={(e) => { e.target.src = `https://images.unsplash.com/photo-1570872626485-d8ffea69f463?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8Y2x1YnxlbnwwfHwwfHx8MA%3D%3D` }} /></span>
                    <p className="event-card-club-name">
                        {clubName?.length > 25 ? clubName?.slice(0, 25) + '...' : clubName}
                    </p>
                </div>
                <div>
                    <p className="event-card-discount-addon">
                        {addon > 0 ? `${addon}% Addon` : "No Addon"} | {discount > 0 ? `${discount}% Discount` : "No Discount"}
                    </p>

                </div>
                <div className="event-card-meta">
                    <div className='event-card-time-date'>
                        <span>
                            <FaCalendarAlt /> {date}
                        </span>
                        <span>
                            <FaClock /> {time}
                        </span>
                    </div>
                    <div className='event-card-rating'>
                        <span>
                            <FaStar /> {rating}
                        </span>
                    </div>
                </div>
                <div className="event-card-location">
                    <span>
                        <FaMapMarkerAlt /> {location}
                    </span>
                    <span className="event-card-distance">{Number(distance) > 0 ? distance : "--"} kms</span>
                </div>
                <div className="event-card-extra">
                    <div className='event-card-type-price'>
                        <span>
                            <FaDoorOpen /> {type}
                        </span>
                        <span>
                            {price > 0 && <FaRupeeSign />} {price > 0 && price}
                        </span>
                    </div>

                    {isPastDate(date) ? (
                        <div className='event-card-button-expried'>
                            <button>Event Expried</button>
                        </div>
                    ) : (
                        <>
                            {!isEventThankyou && (
                                isCarnival ? (
                                    <Link to={`/carnival-book/${clubid}/${eventid}`} style={{ textDecoration: "none" }}>
                                        <div className='event-card-button'>
                                            <button>Book Now</button>
                                        </div>
                                    </Link>
                                ) : (
                                    <Link to={`/event-book/${clubid}/${eventid}`} style={{ textDecoration: "none" }}>
                                        <div className='event-card-button'>
                                            <button>Book Now</button>
                                        </div>
                                    </Link>
                                )
                            )}
                        </>

                    )}
                </div>
            </div>
        </div >
    );
};

export default EventsListingCard;

